










import { Vue, Component } from "vue-property-decorator";
import topItem from "@/components/common/header/index.vue";
import { Cell, Pagination, Button, Loading } from "vant";

@Component({
  components: {
    [Cell.name]: Cell,
    [Pagination.name]: Pagination,
    [Button.name]: Button,
    [Loading.name]: Loading,
    topItem,
  },
})
export default class empowermentQueryComponent extends Vue {
  loading = false;
  componentName = topItem;
  detailContent = "";
  id: any = "";
  created() {}

  mounted() {}
  goRegister() {
    let token = localStorage.getItem("token");
    if (token) {
      // deliver
      this.$router.push({ path: "deliverResume", query: { id: this.id } });
    } else {
      this.$router.push({ path: "register", query: { id: this.id } });
    }
  }
  goBack() {
    this.$router.push("/home");
  }
}
